<div class="loading" *ngIf="loadingService.loading">
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <span class="sr-only">Loading...</span>
</div>
